module.exports = __webpack_public_path__ + "img/Weapon_285.43410d29.png";